// extracted by mini-css-extract-plugin
export default {"root":"GlowCard_root-Dx9"};